import { Link } from "react-router-dom"
import "./css/top_rated_schools.css";

const SearchedSchool = ({school_key, rating, name, district, banner, url}) => {
  return (
    <div className="top_rated_school">
      <p className="banner">
        <span className="rating">{rating}</span>
        <img src={banner} alt={`searched school${banner}`} />
      </p>
      <p className="name">{name}</p>
      <p className="district">{district}</p>
      <Link to={url} target="_blank">View More</Link>
    </div>
  )
}

export default SearchedSchool